/**
 * Per-button AJAX loading spinner - Vastradevi Theme
 * When a button triggers a fetch(), a small spinner shows inside that button
 * until the request settles. No full-screen overlay.
 */
(function () {
  'use strict';

  var BTN_SELECTOR = [
    'button', '.btn-primary', '.btn-secondary', '.btn-gold',
    '.btn-outline-gold', '.btn-outline-white', '.col-card__cta-btn',
    '.cart-drawer__qty-btn', '.cart-page-qty-btn', '.product-qty-btn',
    '.cart-drawer__remove', '.cart-page-remove'
  ].join(',');

  var lastBtn = null;
  var lastClickTime = 0;

  // Buttons that navigate (or otherwise shouldn't show an inline spinner) can
  // opt out via [data-no-loader] or by living inside one of these containers.
  var NO_SPINNER_SELECTOR = '[data-no-loader],.currency-switcher';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(BTN_SELECTOR);
    if (btn && btn.closest(NO_SPINNER_SELECTOR)) btn = null;
    lastBtn = btn || null;
    lastClickTime = Date.now();
  }, true);

  function showSpinner(btn) {
    if (btn.__spinnerEl) return;
    var color = getComputedStyle(btn).color;
    btn.classList.add('vd-btn-loading');
    var sp = document.createElement('span');
    sp.className = 'vd-btn-spinner';
    sp.style.borderColor = color;
    sp.style.borderTopColor = 'transparent';
    btn.appendChild(sp);
    btn.__spinnerEl = sp;
  }

  function hideSpinner(btn) {
    btn.classList.remove('vd-btn-loading');
    if (btn.__spinnerEl) { btn.__spinnerEl.remove(); btn.__spinnerEl = null; }
  }

  function attach(btn) {
    if (btn.__loadTimer) { clearTimeout(btn.__loadTimer); btn.__loadTimer = null; }
    btn.__loadCount = (btn.__loadCount || 0) + 1;
    showSpinner(btn);
  }

  function detach(btn) {
    btn.__loadCount = Math.max(0, (btn.__loadCount || 1) - 1);
    if (btn.__loadCount === 0) {
      // Small grace period so chained requests (e.g. add-to-cart then a cart
      // refresh) keep one continuous spinner instead of flickering.
      btn.__loadTimer = setTimeout(function () { hideSpinner(btn); }, 140);
    }
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  // Background/typeahead requests must NEVER attach a button spinner. The
  // catalog feed in particular is fetched in a paginated loop that keeps
  // firing for seconds after load, and would otherwise latch onto whatever
  // button was clicked most recently.
  var EXCLUDE = [/\/products\.json/, /\/search\/suggest/, /\/suggest\.json/, /\/cart\.js/, /[?&]view=siblings/];

  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var excluded = EXCLUDE.some(function (re) { return re.test(url); });

    // Associate a non-excluded request with the button just clicked (or one
    // already mid-request from a chained call).
    var btn = null;
    if (!excluded && lastBtn && (lastBtn.__loadCount > 0 || (Date.now() - lastClickTime) < 1200)) {
      btn = lastBtn;
    }
    if (btn) attach(btn);

    return nativeFetch.apply(this, arguments).then(
      function (res) { if (btn) detach(btn); return res; },
      function (err) { if (btn) detach(btn); throw err; }
    );
  };
})();
